import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import classNames from 'classnames';
import { Form } from 'react-redux-form';
import Modal from '../ui/modal';
import Filters from '../filtersReporting';
import Headline from '../ui/headline';
import hasRequiredPermissions from '../../helpers/hocs/has-required-permissions';
import Loading from '../ui/loading-spinner';

import Workbook from './workbook-data';
import GenerateModal from './generate-modal';
import ColumnControls from './column-controls';

import * as Table from 'reactabular-table';
import * as sort from 'sortabular';
import * as search from 'searchtabular';
import * as resolve from 'table-resolver';
import * as tree from 'treetabular';

import { compose } from 'redux';
import orderBy from 'lodash/orderBy';
import Paginator from '../../helpers/paginator';
import paginate from '../../helpers/paginate';

class Reporting extends Component {
    constructor(props) {
        super(props);
        this.onSelect = this.onSelect.bind(this);
        this.setRows = this.setRows.bind(this);
        this.setCurrentPage = this.setCurrentPage.bind(this);

        const columns = this.getColumns();

        this.state = {
            data: [],
            sortingColumns: {},
            query: {},
            searchColumn: 'all',
            pagination: {
                page: 1,
                perPage: 20
            },
            tempPage: 0,
            columns
        };
    }
    getColumns() {
        const getSortingColumns = () => this.state.sortingColumns || {};
        const sortable = sort.sort({
            // Point the transform to your rows. React state can work for this purpose
            // but you can use a state manager as well.
            getSortingColumns,

            // The user requested sorting, adjust the sorting state accordingly.
            // This is a good chance to pass the request through a sorter.
            onSort: selectedColumn => {
                this.setState({
                    sortingColumns: sort.byColumn({
                        sortingColumns: this.state.sortingColumns,
                        sortingOrder: {
                            FIRST: 'asc',
                            asc: 'desc',
                            desc: 'asc'
                        },
                        selectedColumn
                    })
                });
            },

            // Use property strategy over index one given we have nested data
            strategy: sort.strategies.byProperty
        });
        const getRows = () => this.state.data;
        const toggleShowingChildren = rowIndex => {
            const rows = this.state.data;
            rows[rowIndex].showingChildren = !rows[rowIndex].showingChildren;
            this.setState({
                data: rows
            });
        };
        return [
            {
                header: {
                    label: 'Event Name',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: true,
                property: 'name',
                cell: {
                    formatters: [
                        tree.toggleChildren({
                            getRows,
                            getShowingChildren: ({ rowData }) =>
                                rowData.showingChildren,
                            toggleShowingChildren,
                            props: {}
                        }),
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    <Link to={`/event/${extra.rowData.id}`}>
                                        {name}
                                    </Link>
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Handheld/iPad Event',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: true,
                property: 'isFromEac',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Source Code',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'sourceCode',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Status',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: true,
                property: 'subStatus',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Event Cost',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'cost',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    }).format(name)}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Electronic Forms Submitted',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'handHeldLeads',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Region',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'RegionName',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'District',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'DistrictName',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'RS',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'RecruitingStationName',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'RSS/OSS',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'RecruitingSubStationName',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: { label: 'Category' },
                visible: true,
                property: 'customCategory',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Est Attendance',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'estimatedTargetAttendance',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'EMV Attended',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportemvAttend',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Paper Lead Cards',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportleadCards',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Qty Rcvd',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'TotalQtyReceived',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Incomplete',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'Incomplete',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Not Legible',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'TotalNotLegible',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Checked Yes',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'TotalCheckedYes',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Checked No',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'TotalCheckedNo',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Invalid Information',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'InvalidInformation',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Purged',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'Purged',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Qualified Market',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'TotalQualifiedMarket',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Total Response',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'TotalResponse',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'First Response',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'FirstResponse',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Qualified Leads',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'QualifiedLead',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'PPC',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'PPC',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Enlisted Contract',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'Contract',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Cost Per PPC',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportcostPerPPC',
                cell: {
                    formatters: [
                        (name, extra) => {
                            let title = name;
                            if (!isNaN(name)) {
                                title = new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD'
                                }).format(name);
                            }
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {title}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Cost Per Enl Contract',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportcostPerEnlisted',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Officer Qualified Lead',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'OfficerQualifiedLead',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Officer Applications',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'OfficerApplication',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Start Date',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: true,
                property: 'startDate',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'African American',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'ethnicityAfricanAmerican',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Asian',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'ethnicityAsian',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Caucasian',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'ethnicityCaucasian',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Hispanic',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'ethnicityHispanic',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Other Ethnicity/Race',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'ethnicityOther',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Ethnicity/Race N/A',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'ethnicityNA',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Male',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'genderMale',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Female',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'genderFemale',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Influencer Lead Cards',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportinfluencerLeadCards',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Appointments Scheduled',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportinterviewsScheduled',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Actual Attendees',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportattendance',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Number of Influencers',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportinfluencersAttended',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Number of Influencers Engaged',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportinfluencersEngaged',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Direct Engagement with Attendees',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportdirectEngaged',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Social Media Posts',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportsocialMediaPosts',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Social Media Impressions',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportsocialMediaImpressions',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Traditional Media Posts',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReporttraditionalMediaPosts',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Traditional Media Impressions',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReporttraditionalMediaImpressions',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'Number of Influencer Contact Information Obtained',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportinfluencerContacts',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            },
            {
                header: {
                    label: 'On-Site Activations',
                    transforms: [sortable],
                    formatters: [
                        sort.header({
                            sortable,
                            getSortingColumns,
                            strategy: sort.strategies.byProperty
                        }),
                        name => (
                            <div>
                                {name}
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        )
                    ]
                },
                visible: false,
                property: 'EventReportonsiteActivations',
                cell: {
                    formatters: [
                        (name, extra) => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        {extra.column.header.label}
                                    </span>
                                    {name}
                                </div>
                            );
                        }
                    ]
                }
            }
        ];
    }

    componentDidMount() {
        this.props.reportingCategory();
        this.props.onLoadReportingLocations('reportingFilters');
        this.props.fetchReportingResults();
        this.getColumns();
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            data: nextProps.data
        });
    }

    handleSubmit = e => {
        this.props.fetchReportingResults();
        this.props.toggleReportingFilters(true);
    };

    onSelect(page) {
        const pages = Math.ceil(
            this.state.data.length / this.state.pagination.perPage
        );

        this.setState({
            pagination: {
                ...this.state.pagination,
                page: Math.min(Math.max(page, 1), pages)
            }
        });
    }
    setRows(event) {
        const pagination = this.state.pagination || {};

        pagination.perPage = parseInt(event.target.value, 10);
        pagination.page = 1;

        this.setState({
            pagination: pagination
        });
    }
    setCurrentPage(event) {
        const pagination = this.state.pagination || {};

        pagination.page = parseInt(event.target.value, 10);

        this.setState({
            pagination: pagination
        });
    }

    render() {
        const GenerateReportBtn = hasRequiredPermissions({
            Event: ['Reporting']
        })(GenerateModal);

        const {
            searchColumn,
            sortingColumns,
            columns,
            query,
            pagination,
            data
        } = this.state;

        const visibleColumns = columns.filter(column => column.visible);

        const resolvedRows = resolve.resolve({
            columns: visibleColumns
        })(data);
        const sortedRows = compose(
            paginate(pagination),
            tree.filter({ fieldName: 'showingChildren' }),
            sort.sorter({
                columns: visibleColumns,
                sortingColumns,
                sort: orderBy,
                strategy: sort.strategies.byProperty
            }),
            tree.search({
                operation: search.multipleColumns({
                    columns: visibleColumns,
                    query
                })
            })
        )(resolvedRows);
        const sortRowsAll = compose(
            tree.filter({ fieldName: 'showingChildren' }),
            sort.sorter({
                columns: visibleColumns,
                sortingColumns,
                sort: orderBy,
                strategy: sort.strategies.byProperty
            }),
            tree.search({
                operation: search.multipleColumns({
                    columns: visibleColumns,
                    query
                })
            })
        )(resolvedRows);
        return this.props.getReportingLoading ? (
            <Loading />
        ) : (
            <div className="reporting">
                <Headline title="Reporting" tagValue="1" />
                <span className="reporting-data-range">
                    Date Range:{' '}
                    {Moment(this.props.startDate).format('YYYY-MM-DD')} -{' '}
                    {Moment(this.props.endDate).format('YYYY-MM-DD')}
                </span>

                <div
                    id="overlay-bg"
                    onClick={this.props.toggleReportingFilters}
                    className={classNames({
                        'is-active': this.props.reportingFiltersActive
                    })}
                />

                <Form onSubmit={this.handleSubmit} model="reportingFilters">
                    <Filters
                        closeOnClick={this.props.toggleReportingFilters}
                        model="reportingFilters"
                        isActive={this.props.reportingFiltersActive}
                        reportingCategoryList={this.props.reportingCategoryList}
                    />
                </Form>

                <button
                    onClick={this.props.toggleReportingFilters}
                    className={classNames(
                        'panel__link',
                        'panel__link--reporting-filter',
                        { 'is-active': this.props.reportingFiltersActive }
                    )}
                >
                    <svg className="icon icon-filter">
                        <use xlinkHref="#icon-filter" />
                    </svg>
                </button>

                <span className="form__title">Filter Reports:</span>

                <search.Field
                    column={searchColumn}
                    query={query}
                    columns={visibleColumns}
                    rows={sortedRows}
                    onColumnChange={searchColumn =>
                        this.setState({ searchColumn })
                    }
                    onChange={query => this.setState({ query })}
                    className="reporting__search"
                    placeholder="Start typing"
                />

                <div className="reporting-controls">
                    <div className="reporting__ctas">
                        <Modal
                            title="Manage Columns"
                            classes="btn align-left btn--reporting"
                            modalClassName="modal--reporting"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.modalReporting}
                            toggleModal={this.props.toggleModalReporting}
                        >
                            <ColumnControls
                                toggleModal={this.props.toggleModalReporting}
                                columns={columns}
                            />
                        </Modal>

                        {GenerateReportBtn && (
                            <GenerateReportBtn
                                modalGenerateReporting={
                                    this.props.modalGenerateReporting
                                }
                                toggleGenerateModalReporting={
                                    this.props.toggleGenerateModalReporting
                                }
                                jwtToken={this.props.jwtToken}
                            />
                        )}

                        <Workbook
                            workbookData={sortRowsAll}
                            workbookColumns={visibleColumns}
                        />
                    </div>

                    {sortedRows.rows.length > 0 ? (
                        <div>
                            <div className="table__outer-container">
                                <Table.Provider
                                    className="table"
                                    columns={visibleColumns}
                                >
                                    <Table.Header className="table__header" />

                                    <Table.Body
                                        rows={sortedRows.rows}
                                        rowKey="id"
                                        className={'table__body'}
                                    />
                                </Table.Provider>
                            </div>
                            <div className="controls">
                                <Paginator
                                    pagination={pagination}
                                    pages={sortedRows.amount}
                                    page={sortedRows.page}
                                    onSelect={this.onSelect}
                                    setPerPage={this.setRows}
                                    setPage={this.setCurrentPage}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="table__no-results">No Results.</div>
                    )}
                </div>
            </div>
        );
    }
}

export default Reporting;



// WEBPACK FOOTER //
// ./src/components/reporting/index.js